import { Typography, Button, Grid } from '@mui/material';

export const AvailabilityError = ({ onRetry }) => {
  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Typography variant="subtitle1" color="error" align="center">
          Lo sentimos, esta habitación no está disponible
        </Typography>
      </Grid>
      {onRetry && (
        <Grid item>
          <Button variant="contained" color="primary" onClick={onRetry}>
            Reintentar
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
